import { UtilsUsecase } from "./types";
import { updateEndorse } from "@/hooks/useEndorsement";

export async function endorsementUsecase(payload: any, utils: UtilsUsecase) {
  try {
    await updateEndorse(
      payload?.id,
      payload?.purpose === "ACCEPTED" ? "APPROVED" : "DENIED",
      payload?._version
    );

    await utils.refetch();

    utils.successModal({
      show: true,
      title:
        payload?.purpose === "ACCEPTED"
          ? "Endorsement Added"
          : "Endorsement Declined",
      body: `Endorsement from ${payload?.name} ${
        payload?.purpose === "ACCEPTED"
          ? "has been added to your profile."
          : "has been declined"
      }`,
    });
  } catch (error: any) {
    utils.errorModal({
      title: "Error",
      body:
        error?.errors?.[0]?.message ||
        `Endorsement from ${
          payload?.purpose === "ACCEPTED"
            ? "added to your profile"
            : "is rejected"
        } failed, please try again.`,
      show: true,
      type: "error",
    });
  }
}

